import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ManagingAccountService {

  constructor(protected http: HttpClient) { }

  find(query?): Observable<any[]> {
    return this.http.get<any[]>(`managing-accounts`, { params: query });
  }
}
